module.exports = __webpack_public_path__ + "static/media/imagePromo.bd89d406.png";